export let SECURE_3D = null;

export const initSecure3d = (merchantCode, jwt) => {
    SECURE_3D = new Secure3D();
    SECURE_3D.logging(true);
    SECURE_3D.setup(merchantCode, jwt);
    SECURE_3D.enableBinDetection('cardNumber');
}